var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _vm.hosting_error
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "app-card",
                  attrs: {
                    text: ""
                  }
                },
                [
                  _c("v-card-text", [
                    _c(
                      "p",
                      {
                        staticClass: "mb-0"
                      },
                      [_vm._v(_vm._s(_vm.hosting_error))]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : [
            _c(
              "v-col",
              {
                attrs: {
                  cols: "12"
                }
              },
              [
                _c("service-limits", {
                  attrs: {
                    loading: _vm.loading
                  }
                }),
                _c("service-domain-server-info", {
                  staticClass: "pb-0 pt-3",
                  attrs: {
                    loading: _vm.loading
                  }
                }),
                _c("service-info")
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }